/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import {Tooltip, TooltipProps} from '@mui/material';
import React from 'react';

/**
 * MUI `<Tooltip />` wrapped with Viasat Beam styles.
 * @param props Additional tooltip props
 * @constructor
 */
const BeamTooltip = (props: TooltipProps) => {
  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          style: {
            fontSize: '12px',
            backgroundColor: '#111920',
            padding: '12px 16px',
            ...props.componentsProps?.tooltip?.style,
          },
          ...props.componentsProps?.tooltip,
        },
        arrow: {
          style: { color: '#111920', ...props.componentsProps?.arrow?.style },
          ...props.componentsProps?.arrow,
        },
      }}
      arrow={true}
      {...props}
    >
      {props.children}
    </Tooltip>
  );
};

export default BeamTooltip;
